<script setup>
const props = defineProps({
  title: String,
  text: String,
})
</script>

<template>
  <div class="slider-card relative flex flex-col justify-center">
    <div class="circle-pink absolute"></div>
    <div class="circle-blue absolute"></div>
    <h3 class="text-xxl relative">{{ title }}</h3>
    <p class="text-m relative">{{ text }}</p>
  </div>
</template>

<style scoped lang="scss">
.slider-card {
  border-radius: clamp(28px, 1.944vw, 140px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: #070707;
  box-shadow: 0px 4px 18px 0px rgba(255, 255, 255, 0.25);
  padding: 3.75vw;
  width: clamp(400px, 42.153vw, 3035px);
  height: clamp(367px, 25.486vw, 2000px);
  overflow: hidden;
  p {
    line-height: normal;
    width: 70%;
    margin: clamp(62px, 4.306vw, 310px) 0 0;
    z-index: 2;
  }
  h3 {
    width: 70%;
    z-index: 2;
  }
  .circle-pink {
    left: -30%;
    top: 60%;
  }
  .circle-blue {
    top: -20%;
    left: 60%;
  }
}

@media (max-width: 768px) {
  .slider-card {
    width: 100%;
    min-height: 367px;
    height: auto;
    padding: 26px;
    h3 {
      font-size: 25px;
      line-height: 103%;
    }
    p {
      font-size: 18px;
      font-weight: 400;
      line-height: normal;
      margin: 59px 0 0;
    }
  }
}
</style>